import { useNavigate, useParams } from 'react-router-dom';

const useSystemCodeSearch = () => {
  const { systemCodeId } = useParams();
  const navigate = useNavigate();

  const systemCodeSelected = (selectedSystemCodeId: string) => {
    // Safely convert both to numbers for comparison
    const currentSystemCodeId = systemCodeId ? parseInt(systemCodeId, 10) : undefined;
    const selectedId = parseInt(selectedSystemCodeId, 10);

    if (currentSystemCodeId !== undefined && selectedId === currentSystemCodeId) {
      return;
    }
    void navigate(`/codes/${selectedId}`);
  };

  return {
    systemCodeId,
    systemCodeSelected
  };
};

export default useSystemCodeSearch;
